import { render } from "./ReturnRefundPolicy.vue?vue&type=template&id=3f290a10"
import script from "./ReturnRefundPolicy.vue?vue&type=script&lang=js"
export * from "./ReturnRefundPolicy.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__